import React, { Component } from 'react'
import { Grid, withStyles, Paper } from '@material-ui/core'
import MenuBar from '../components/header/MenuBar'
import SearchBar from '../components/SearchBar'
import Footer from '../components/Footer'
import starIcon from 'images/svg/star-icon.svg'
import { trackPage } from 'utils'
import FlashMessage from 'components/FlashMessage'
import pointingCaveman from 'images/Pointing_UG_Left.png'
import ugsellsImage from 'images/WSUH_1Line_K.png'
import uglyHouses from 'images/ugly_houses.png'

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  root: {
    display: 'block',
    padding: '0px',
    width: '100%',
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing.unit,
  },
  aboutCards: {
    background: 'transparent',
    boxShadow: 'none',
  },
  aboutVestorstitle: {
    fontSize: '26px',
    fontWeight: '500',
    letterSpacing: '-0.36px',
    color: '#00bcb5',
    padding: '44px 0 24px',
    margin: '0',
    [theme.breakpoints.down('960')]: {
      padding: '20px 0',
      fontSize: '20px',
    },
  },
  abouttrustedtitle: {
    color: '#fff',
  },
  aboutvestorsPara: {
    fontSize: '18px',
    color: '#000000',
    paddingBottom: '25px',
    lineHeight: '25px',
    margin: '0',
    [theme.breakpoints.down('960')]: {
      fontSize: '16px',
    },
  },
  abouttrustedPara: {
    color: '#fff',
    fontWeight: '500',
  },
  aboutvestorsParabottom: {
    paddingBottom: '58px',
    margin: '0',
    [theme.breakpoints.down('960')]: {
      paddingBottom: '30px',
    },
  },

  premiumList: {
    width: '80%',
    listStyle: 'none',
    padding: '0',
    margin: '0',
    '& li': {
      display: 'flex',
      alignItems: 'flex-start',
      fontSize: '18px',
      color: '#fff',
      marginTop: '24px',
      [theme.breakpoints.down('960')]: {
        fontSize: '16px',
        lineHeight: '1.5',
        margin: '0 0 24px',
      },
      '& img': {
        display: 'block',
        width: '22px',
        margin: '0 12px 0 0',
        flex: 'none',
      },
    },
  },

  gridList: {
    margin: '0px auto',
    width: 'auto',
    maxWidth: '1240px',
    [theme.breakpoints.down('1241')]: {
      maxWidth: '97%',
    },
  },
  trustedListSection: {
    backgroundColor: '#00bcb5',
    padding: '0 0 50px',
    [theme.breakpoints.down('960')]: {
      padding: '0',
    },
  },
  gridFlex: {
    display: 'flex',
  },
  listWrapper: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  caveman: {
    width: '100px',
    objectFit: 'contain',
  },
  ugsells: {
    maxWidth: '80%',
    height: '50px',
    objectFit: 'contain',
  },
  uglyHouses: {
    width: '100px',
    objectFit: 'contain',
  },
})

class AboutUs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showSettings: false,
      showDetail: false,
    }
  }

  componentDidMount() {
    trackPage(window.location.pathname)
    window.scrollTo(0, 0)
  }

  toggleDetail() {
    const { showDetail } = this.state
    this.setState({
      showDetail: !showDetail,
    })
  }

  render() {
    const { showSettings } = this.state
    const { classes } = this.props

    return (
      <Grid container>
        {/* <NetworkIssue /> */}
        <Grid item xs={12}>
          <MenuBar hidePremium={true} showSettings={showSettings} setShowSettings={this.setShowSettings} />
        </Grid>
        <Grid item xs={12}>
          <SearchBar withoutSearchBox aboutUs />
        </Grid>
        <div className={classes.root}>
          <Grid container spacing={24} className={classes.gridList}>
            <Grid item>
              <Paper className={classes.aboutCards}>
                <h3 className={classes.aboutVestorstitle}>We Sell Ugly Houses&reg;</h3>
                <p className={classes.aboutvestorsPara}>
                  Get investment leads backed by America’s #1 Home Buyer, HomeVestors®, who is also known as the “We Buy Ugly Houses”® people. Since 1996,
                  HomeVestors has bought more than 100,000 properties and our over 1,100+ franchisees represent the country’s largest network of professional
                  real estate investors. Along the way, we’ve perfected the art of finding leads on investment properties with substantial upside potential.
                </p>
                <p className={`${classes.aboutvestorsPara} ${classes.aboutvestorsParabottom}`}>
                  DealVestors&reg; was created to give other investors access to our tremendous pool of investment properties. You’ll find properties our
                  franchisees have renovated, as well as others that are in need of rehabbing. Whether you’re looking for a property that’s ready for renovating
                  or ready for renting, you’ll find smart, fast and fair deals with DealVestors&reg;.
                </p>
              </Paper>
            </Grid>
          </Grid>
          <Grid className={classes.trustedListSection}>
            <Grid container spacing={24} className={classes.gridList}>
              <Grid item>
                <Paper className={classes.aboutCards}>
                  <img className={classes.ugsells} src={ugsellsImage} alt="ugsells" />
                  <h3 className={`${classes.aboutVestorstitle} ${classes.abouttrustedtitle}`}>UG Sells Ugly Houses&reg;</h3>
                  <p className={`${classes.aboutvestorsPara} ${classes.abouttrustedPara}`}>
                    HomeVestors is the trusted industry leader with an well established reputation within the industry for real estate investment effectiveness
                    and success.
                  </p>
                  <div className={classes.listWrapper}>
                    <ul className={classes.premiumList}>
                      <li>
                        <img alt="star" src={starIcon} />
                        <span className={classes.aboutbullets}>Six consecutive years on Entrepreneur Magazine’s “Franchise 500”</span>
                      </li>
                      <li>
                        <img alt="star" src={starIcon} />
                        <span className={classes.aboutbullets}>
                          Eight consecutive years on Franchise Business Reviews’s “Top 50 Franchise Satisfaction Award”
                        </span>
                      </li>
                      <li>
                        <img alt="star" src={starIcon} />
                        <span className={classes.aboutbullets}>More than 1,000 franchisees in 47 states and Washington D.C.</span>
                      </li>
                    </ul>
                    <img className={classes.caveman} src={pointingCaveman} alt="caveman" />
                  </div>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={24} className={classes.gridList}>
            <Grid item>
              <Paper className={classes.aboutCards}>
                <h3 className={classes.aboutVestorstitle}>DealVestors&reg; Has The Property You’re Looking For</h3>
                <div className={classes.gridFlex}>
                  <img className={classes.uglyHouses} src={uglyHouses} alt="I love Ugly Houses." />
                  <p className={`${classes.aboutvestorsPara} ${classes.aboutvestorsParabottom}`}>
                    Houses. Condos. Townhomes. Multi-family properties. Whether you’re looking to purchase a single property or build a portfolio,
                    DealVestors&reg; has a property that fits your real estate investment strategy.
                  </p>
                </div>
              </Paper>
            </Grid>
          </Grid>
        </div>
        <Footer />
        <FlashMessage />
      </Grid>
    )
  }
}

export default withStyles(styles)(AboutUs)



// WEBPACK FOOTER //
// ./src/containers/AboutUs.js